import {Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {AgentBranchSideCostGrid} from "./grid";
import {AgentBranchSideCostForm} from "./form";
import {getAgentBranchSideCosts} from "../../services/agent_branch_side_cost/agent_branch_side_cost";
import {CardFooterPaginator} from "../system/cardFooterPaginator";
import {AgentBranchSideCostContext} from "../../context/agent_branch_side_cost";
import {PaginateContext} from "../../context/paginate";


export function AgentBranchSideCostManagement() {

  const [agentBranchSideCosts, setAgentBranchSideCosts] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getAgentBranchSideCosts(paginate);
    if (result.status === 200) {
      const {agentBranchSideCostList, total_count} = result.data;
      setAgentBranchSideCosts(agentBranchSideCostList || []);
      setGridTotalRowCount(total_count);
    }
  }

  useEffect(() => {
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(paginate)
  }, [lastDataRefresh, gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <AgentBranchSideCostContext.Provider value={{
      agentBranchSideCosts: agentBranchSideCosts,
      agentBranchSideCost: gridSelectedRow,
      setAgentBranchSideCost: setGridSelectedRow,
      open: modalOpen,
      setOpen: setModalOpen,
      setLastDataRefresh: setLastDataRefresh,

    }}>
      <PaginateContext.Provider value={{
        setSortBy: setSortBy,
        sortType: sortType,
        setSortType: setSortType,
        active: gridCurrentPage,
        setActive: setGridCurrentPage,
        totalRows: gridTotalRowCount,
        rowsCount: gridRowCount,
        setRowsCount: setGridRowCount,
        from: from,
        to: to,
      }}>
        <div className="">
          <AgentBranchSideCostForm/>
          <Card className="pt-8">

            <CardHeader floated={true} shadow={false} className="rounded-none">
              <div className="mb-8 flex items-center justify-between gap-8">
                <Typography variant="h5" color="blue-gray">هزینه‌های دولتی و جانبی</Typography>
                <Button onClick={() => {
                  setGridSelectedRow(null);
                  setModalOpen(true);
                }} variant="outlined">جدید</Button>
              </div>
            </CardHeader>

            <CardBody className="overflow-x-auto w-full">
              <AgentBranchSideCostGrid/>
            </CardBody>
            <CardFooterPaginator/>
          </Card>
        </div>
      </PaginateContext.Provider>
    </AgentBranchSideCostContext.Provider>
  );
}